import React, {useContext, useEffect} from 'react';
import {FormOperacionTransferenciaTerceros, OperacionTransferenciaTerceros} from "./types/types";
import {ContextOperacion, ContextOperacionType} from "../../RefactorLayout";
import {useForm} from "react-hook-form";
import {schemaFormOperacionNotaEstructurada} from "../nota_estructurada/types/types";
import {zodResolver} from "@hookform/resolvers/zod/dist/zod";
import {useLoader} from "../../../../hooks/useLoader";
import {EntityWithIdFields, QueryStatus} from "../../../../types";
import {Alert, Grid} from "@mui/material";
import {SeccionFirmas} from "../../components/SeccionFirmas";
import {SistemaTipo} from "../../../../types/enum/enum";
import SeccionTransferenciaTercerosDatosOperacion from "./components/SeccionTransferenciaTercerosDatosOperacion";
import {useOperacionTransferenciaTerceros} from "./hooks/useOperacionTransferenciaTerceros";
import SeccionTransferenciaTercerosCuentas from "./components/SeccionTransferenciaTercerosCuentas";
import {
  SeccionTransferenciaTercerosChequeosCompliance
} from './components/SeccionTransferenciaTercerosChequeosCompliance';
import SeccionTransferenciaTercerosFinalizar from "./components/SeccionTransferenciaTercerosFinalizar";
import {OperacionTransferenciaTercerosFields} from "./types/fields";

interface SistemaTransferenciaTercerosContentProps {
  operacion: OperacionTransferenciaTerceros
}

const SistemaTransferenciaTercerosContent = ({operacion}: SistemaTransferenciaTercerosContentProps) => {


  const formMethods = useForm<FormOperacionTransferenciaTerceros>({
    resolver: zodResolver(schemaFormOperacionNotaEstructurada),
    values: {...operacion}
  })


  return (
    <>
      <Grid container spacing={4}>
        <Grid item xs={12}>
          <SeccionTransferenciaTercerosDatosOperacion
            formMethods={formMethods}
            codSistemaPrincipal={operacion[OperacionTransferenciaTercerosFields.CodPais]}
            readOnly={true}
            operacion={operacion}
            nuevo
          />
        </Grid>
        <Grid item xs={12}>
          <SeccionTransferenciaTercerosCuentas
            codPais={operacion[OperacionTransferenciaTercerosFields.CodPais]}
            operacionId={operacion[EntityWithIdFields.Id]}
          />
        </Grid>
        <Grid item xs={12}>
          <SeccionTransferenciaTercerosChequeosCompliance
            idOperacion={operacion[EntityWithIdFields.Id]}
            expandir={operacion[OperacionTransferenciaTercerosFields.VisualizaExpandidoCompliance]}
            permiteEditar={operacion[OperacionTransferenciaTercerosFields.PermiteEditarCompliance]}
          />
        </Grid>

        <Grid item xs={12}>
          <SeccionFirmas
            codSistema={SistemaTipo.TransferenciaTerceros}
            idOperacion={operacion[EntityWithIdFields.Id]}
          />
        </Grid>
        <Grid item xs={12}>
          <SeccionTransferenciaTercerosFinalizar operacion={operacion}
                                                 expandir={operacion[OperacionTransferenciaTercerosFields.VisualizaExpandidoFinalizar]}
                                                 permiteEditar={operacion[OperacionTransferenciaTercerosFields.PermiteEditarFinalizar]}
          />
        </Grid>
      </Grid>
    </>
  )
}

function SistemaTransferenciaTerceros() {
  const {idOperacion} = useContext<ContextOperacionType>(ContextOperacion)

  const {status, operacion} = useOperacionTransferenciaTerceros(idOperacion)

  const {showLoader, hideLoader} = useLoader()

  useEffect(() => {
    if (status === QueryStatus.Loading) {
      showLoader()
    } else {
      hideLoader();
    }
  }, [status])

  if (!operacion) {
    return (
      <>{JSON.stringify(operacion)}</>
    )
  }

  if (status === QueryStatus.Error) {
    return (
      <Alert severity='error'>
        Se produjo un error al cargar la operación.
      </Alert>
    )
  }

  return (
    <SistemaTransferenciaTercerosContent
      operacion={operacion}
    />
  )
}

export default SistemaTransferenciaTerceros;